/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  getMonthName,
  fetchApi
} from "../../../utils/methods";
import { imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  Border,
  EditorContainer,
} from "../../CreateEvent/style";
import StepsHeading from "../../RecogntionAdmin/corevalues/stepNames"; 
import { Main } from "../../AdminTeamCreation/styles";
import { closeIcon, UploadHDMIcon, RecognitionCloseIcon, /*AdminRightArrowIcon, AdminLeftArrowIcon*/ } from '../../../utils/icons';
import { TitleContainer} from './styles';
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { FormHeading } from "../ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import Editor from '../../CKEditor';
import {CommonButtonPopup} from '../../ReportsV2/styles'
import {CommonButtonBorder} from '../../common/commonStyles'
import { GetWellbeingPillars, AddChallengeLibrary, GetChallengeTypeList } from '../../../redux/constants/apiConstants';

class CreateActivityChallenge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      buttonClickScrollTop: false,
      title: '',
      description: '',
      imageName: '',
      imgSrc: '',
      imageUpdated: 0,
      buttonStatus: false,
      selectedChallengeType: null,
      selectedChallengeTypeId: null,
      so: false,
      dropdownOpen: false,
      themeOpen: false,
      charCount:0,
      challengeTypes:[],
      wellbeingPillars:[],
      selectedWellbeingPillar: null,
    };
  }

  componentDidMount() {
    this.fetchChallengeTypes();
    this.getAllWellbeingPillars();
  }

  fetchChallengeTypes = async () => {
    try {
      const res = await fetchApi(`${GetChallengeTypeList}?language_id=1`, 'GET');
      //   console.log("challengeTypes",res)
      if (res.statusCode === 200 || res.statusCode === 201) {
        this.setState({ challengeTypes: res.data || [] });
        
      } else {
        toast.error(res.message);
        
      }
    } catch(error) {
      toast.error(error.message);
    }
  }

  getAllWellbeingPillars = async () => {
    try {
      const res = await fetchApi(GetWellbeingPillars, 'GET');
      if (res.status === 'success') {
        this.setState({ wellbeingPillars: [{ id: null, pillar_title: 'None' }, ...(res.data || [])] });
      } else {
        toast.error(res.message);
      }
    } catch(error) {
      toast.error(error.message);
    }
  }

  stepsHeadingEvent = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1
    },
    {
      name: 'Customize Challenge',
      showArrow: false,
      number: 2
    }
  ]; 

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={() => window.history.back() }>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Activity Challenge")}
    </FormHeading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  //   onChangeDescription = (e) => {
  //     const newContent = e.getData();
  //     const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
  //     trimmedString.length === 0 ||
  //     trimmedString.length === 7 ||
  //     trimmedString == "<p></p><p></p>"
  //       ? this.setState({ description: "" })
  //       : this.setState({ description: newContent });
  //   };

  handleImageChange = (imgSrc) => {
    this.setState({ imgSrc });
  };

  handleRemoveImage = () => {
    this.setState({ imgSrc: "" });
  };

  onChange = (e) => {
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        const array = document.getElementById('create-challenge-file').value.split("\\");
        reader.onloadend = () => {
          this.setState({
            imgSrc: reader.result,
            imageName: array[array.length - 1],
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: baseImage,
                imageUpdated: this.props.editLibrary ? 1 : 0
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('create-challenge-file').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('create-challenge-file').value = '';
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: '',
      imageName: '',
    });
  };

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });

    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); // Strip HTML tags for char count
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      imgSrc,
      charCount
    } = this.state;
    const { t } = this.props;
    // const maxLength = 3000;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeCreate"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter challenge title")}
                    name="title"
                    value={title}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/30 | C</div>
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Challenge image")}{<span className="imp">*</span>}<span className="subtext">{("(Size limit up to 2 MB)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.handleImageChange}
                  onRemoveImage={this.handleRemoveImage}
                  acceptText={'(1920px * 1080px)'}
                />
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />        
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("About the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      placeholder="Enter challenge description"
                      onChange={this.onChangeDescription}
                      //   maxLength={maxLength}
                    //   onChange={(data, count) => this.setState({ description: data, charCount: count, disableButton: false })}
                    />
                  </EditorContainer>

                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  handleSelectChallengeType = (item) => {
    this.setState({
      selectedChallengeTypeId: item.id,
      selectedChallengeType: item.challenge_type || item.name || item.value,
    });
  };

  onSelectTheme = (item) => {
    this.setState({ selectedWellbeingPillar: item });
  };

  createLibraryChallenge = async () => {
    const { title, description, imgSrc, selectedChallengeTypeId, selectedWellbeingPillar } = this.state;
    this.setState({ buttonStatus: true });
    try {
      const res = await fetchApi(AddChallengeLibrary, 'POST', {
        title,
        body: description,
        image: imgSrc,
        challenge_type_id: selectedChallengeTypeId,
        pillar_id: selectedWellbeingPillar?.id || null,
      });
      if(res.statusCode === 200 || res.statusCode === 201){
        toast.success(res.message || 'Challenge library created successfully');
        this.props.history.goBack();
      }else{
        toast.error(res.message);
        this.setState({ buttonStatus: false });
      }
    } catch(error) {
      toast.error(error.message);
      this.setState({ buttonStatus: false });
    }
  };

  stepTwoForm = () => {
    const {
      step,
      selectedChallengeType,
      selectedChallengeTypeId,
      challengeTypes,
      wellbeingPillars,
      selectedWellbeingPillar,
    } = this.state;
    const { t } = this.props;
    const themeTitle = selectedWellbeingPillar
      ? selectedWellbeingPillar.id === null
        ? 'None'
        : `${getMonthName(selectedWellbeingPillar.id)} - ${selectedWellbeingPillar.pillar_title}`
      : null;
    return (
      <Layout height="600px">
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeCreate" />
            </div>
            <div className="form">
              <div className="formBody">
                <TitleContainer widthValue="70%" height="auto" padding="15px 0px 0px 0px">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Type of challenge")}
                    isRequired={true}
                    dropdownOpen={this.state.dropdownOpen}
                    placeholder={this.props.t("Select type")}
                    title={selectedChallengeType}
                    id="dropdown-challenge-type"
                    onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                    data={challengeTypes}
                    onSelect={this.handleSelectChallengeType}
                    active={selectedChallengeTypeId}
                    onSelectParameter={["name", "id"]}
                    itemValue={true}
                    valueIndex={0}
                    labelMargin={"0px"}
                    dropIcon={true}
                    fontSize={"14px"}
                  />
                  <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                </TitleContainer>
                <TitleContainer widthValue="70%" height="auto" padding="0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge monthly theme")}
                    isRequired={false}
                    dropdownOpen={this.state.themeOpen}
                    placeholder={wellbeingPillars?.length > 0 ? t("Select monthly theme (optional)") : t("No Themes Available")}
                    title={themeTitle}
                    id="dropdown-monthly-theme"
                    onClick={() => this.setState({ themeOpen: !this.state.themeOpen })}
                    data={wellbeingPillars}
                    onSelect={this.onSelectTheme}
                    active={selectedWellbeingPillar}
                    onSelectParameter={["pillar_title", "id"]}
                    itemValue={true}
                    valueIndex={0}
                    labelMargin={"0px"}
                    t={t}
                    dropIcon={true}
                    fontSize={"14px"}
                    showMonthName={true}
                  />
                </TitleContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true, buttonStatus:false });
  };

  render() {
    const { step, buttonStatus, title, imgSrc, description, selectedChallengeTypeId,charCount } = this.state;
    const isStep2Valid = !!selectedChallengeTypeId;
    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : this.stepTwoForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description || charCount > 3000} onClick={!title||!imgSrc|| !description || charCount > 3000 ?null: () => this.updateStep(2)}>
                Next
                {/* {!title||!imgSrc|| !description ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={buttonStatus || !isStep2Valid} onClick={!buttonStatus && isStep2Valid ? () => this.createLibraryChallenge() : null}>
                {this.props.t("Create Challenge")}
                {/* {buttonStatus || !isStep2Valid ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

CreateActivityChallenge.propTypes = {
  history: PropTypes.object.isRequired,
  editLibrary: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CreateActivityChallenge));
